import { Component, OnInit, AfterViewInit, Inject, OnDestroy } from '@angular/core';
import { ISubscription } from "rxjs/Subscription";
import { ActivatedRoute } from '@angular/router';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { APP_CONFIG, AppConfig } from '../config/app.config.module';
import { Http, Response } from '@angular/http';
import { SharedService} from '../common/shared.service';
import {Layer } from 'leaflet';
import * as L from 'leaflet';
import { TopnavService } from '../header/topnav/topnav.service';
import { Title } from '@angular/platform-browser';
import * as moment from 'moment-timezone';

/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: November 14th 2017
 * 
 * Description: Component class for Contact - /contact
 **/
@Component({
    selector: 'app-contact',
    templateUrl: 'contact.component.html',
    styles: [
        `
        .gmaplink > a:hover {
            text-decoration: none;
            cursor: pointer;
          } 

        .map-responsive {
            border-top:2px solid #1ebebc;
        }

        p {
          color:black;
          font-size:14px;
        }
      
        body {
            font-family: Roboto, sans-serif;
        }

        .mapstyle {
            width:100%;
            height:500px;
            frameborder:0;
            border:0;
        }

        a {
           color: black !important; 
        }


        `
    ]
})

export class ContactComponent implements OnInit, AfterViewInit, OnDestroy{
    loading: boolean = false;
       getTheme(){
        return localStorage.getItem('themeColor');
    }
    private locParam: string;
    private paramSub: ISubscription;
    langID: any;
    lang: any;
    footer = [];
    dataContact= [];
    tltContact;
    mymap;
    marker;
    markers: Layer[] = [];
    popup= L.popup();
    defaultIcon = L.icon({
        iconUrl: 'assets/marker-icon.png',
        shadowUrl: 'assets/marker-shadow.png',
        iconSize:     [25, 41], // size of the icon
        shadowSize:   [40, 41], // size of the shadow
        iconAnchor:   [0, 0], // point of the icon which will correspond to marker's location
        shadowAnchor: [0, 0],  // the same for the shadow
        popupAnchor:  [12, 0] // point from which the popup should open relative to the iconAnchor
    });

    private subscriptionLang: ISubscription;
    private subscription: ISubscription;
    public subscriptionFontType: ISubscription;
    private subscriptionFontSize: ISubscription;

    public fontSize: any = {
        "sizeS" : "14px",
        "sizeM" : "19px",
        "sizeL" : "23px",
        "no_styles" : "0.9em"
    };

    private mStyle: string;
    private fontType: string = 'Arial'; 

    private footerUrl: string = this.config.urlFooter;
    private agcLat:any;
    private agcLong:any;

    public currentDateTime: string;
    public myflag: any;

    constructor(
        private pageTitle: Title,
        private sharedService: SharedService,
        private route: ActivatedRoute, 
        private translate: TranslateService, 
        private http: Http, 
        @Inject(APP_CONFIG) private config: AppConfig,
        private topnavservice: TopnavService,) {

        this.lang = translate.currentLang;

        this.subscriptionLang = translate.onLangChange.subscribe((event: LangChangeEvent) => {
    
            const myLang = translate.currentLang;
        
            if (myLang == 'en') {
        
                translate.get('HOME').subscribe((res: any) => {
                    this.lang = 'en';
                    this.langID = 1;
                    if (this.popup.isPopupOpen)
                      this.popup.closePopup()
                });
                console.log({'popup':this.popup});
            }

            if (myLang == 'ms') {
        
                translate.get('HOME').subscribe((res: any) => {
                    this.lang = 'ms';
                    this.langID = 2;
                    if (this.popup.isPopupOpen)
                      this.popup.closePopup()
                });
                console.log({'popup':this.popup});
                
            }

            if(this.topnavservice.flagLang){
                this.popup.remove();
                this.subscription = this.getContactUs(this.langID);
                //this.mymap.setView([2.9414613,101.6575362], 13);
               
                this.mStyle = 'style="margin: 0px; font-family:' + this.fontType + '; font-size:' + this.fontSize.sizeS + ';"';
                if (this.marker) {
                    this.marker.closePopup();
                    this.updateMarker(this.agcLat, this.agcLong, 
                    this.dataContact[0].footerContentName,
                    this.dataContact[1].footerContentName,
                    this.dataContact[5].footerContentName,
                    this.dataContact[4].footerContentName,
                    this.dataContact[3].footerContentName);
                }     
            }

            this.route.queryParams.subscribe(params => {
                let lng = params['language'];
                if (lng && lng.toLowerCase() == 'my') {
                  this.myflag = {language:"my"};
                  this.translate.setDefaultLang('ms');
                  this.translate.use('ms');
                } else {
                  this.myflag = null;
                } 
              });

           // this.mymap.setView([5.8142568, 108.5806004], 6);
            //this.mymap.setView([2.9414613,101.6575362], 13);
            setTimeout(()=>{
                this.translate.get('pageTitle.home').subscribe((title:string)=>{
                    title = title + this.translate.instant('home.menu.contact');
                  this.sharedService.setTitle(title);
                }); 
              },500);
              
        });

        this.subscriptionFontSize = this.sharedService.fontSizeData.subscribe((data)=>{
            this.fontSize = data;
            if (localStorage.getItem('customFontType')) {
                this.fontType = localStorage.getItem('customFontType');
            }
            this.mStyle = 'style="margin: 0px; font-family:' + this.fontType + '; font-size:' + this.fontSize.sizeS + ';"';
            if (this.marker) {
                this.updateMarker(this.agcLat, this.agcLong, 
                this.dataContact[0].footerContentName,
                this.dataContact[1].footerContentName,
                this.dataContact[5].footerContentName,
                this.dataContact[4].footerContentName,
                this.dataContact[3].footerContentName);
            }
        });

        this.subscriptionFontType = this.sharedService.fontTypeData.subscribe((data)=>{
            this.fontType = data;
            this.mStyle = 'style="margin: 0px; font-family:' + this.fontType + '; font-size:' + this.fontSize.sizeS + ';"';
            if (this.marker) {
                this.updateMarker(this.agcLat, this.agcLong, 
                this.dataContact[0].footerContentName,
                this.dataContact[1].footerContentName,
                this.dataContact[5].footerContentName,
                this.dataContact[4].footerContentName,
                this.dataContact[3].footerContentName);
            }
        });
    }

    ngOnDestroy() {
        if (this.subscriptionLang)
            this.subscriptionLang.unsubscribe();
        if (this.subscription)
            this.subscription.unsubscribe();
        if (this.paramSub)
            this.paramSub.unsubscribe();
        
        this.subscriptionFontSize.unsubscribe();
        this.subscriptionFontType.unsubscribe();
    }

    ngOnInit() {

        this.currentDateTime = moment().format("YYYY-MM-DD")+ ' 00:00:00';
       
        if(!this.langID){
            this.langID = localStorage.getItem('langID');
        }else{
        this.langID = 1;
        }

        this.getDefaultMap();
        this.subscription  = this.getContactUs(this.langID); 
        this.paramSub =  this.route.params.subscribe(params => {
            if (params['loc']) {
                this.locParam = params['loc'];
                setTimeout(()=>{
                this.goToMarkerPoint(this.locParam);
                },500);
            }    
        });        
    }

    ngAfterViewInit() {
      
        // Get Title and Sent to GA
    	this.translate.get('pageTitle.home').subscribe((title:string) => {
            title = title + this.translate.instant('home.menu.contact');
            this.sharedService.setTitleAndGtag(title);
        });
        this.sharedService.loadFontSizeData();
    }

    getContactUs(lang){
        this.loading = true;
        return this.http.get(this.footerUrl + '?language=' + lang )
        .map((response: Response) => response.json())
        .subscribe(resSliderData => {
            this.footer = resSliderData['footerResourceList'];    
         

            if(lang == 2){
                this.tltContact = this.footer.filter(fdata => fdata.title === 'HUBUNGI KAMI')[0];
            }

            else{
                this.tltContact = this.footer.filter(fdata => fdata.title === 'CONTACT US')[0];
            }
            //console.log(this.tltContact);    
            this.dataContact = this.tltContact.footerContents;
            let latlong = this.dataContact[2].footerContentName;
            
            ///let latlong2 = this.dataContact[4].footerContentName;        
            var partsOfStr = latlong.split(',');
            this.agcLat = parseFloat(partsOfStr[0]);
            this.agcLong = parseFloat(partsOfStr[1]);
            //var partsOfStr2 = latlong2.split(',');  
            
            this.addMarker(
                parseFloat(partsOfStr[0]),
                parseFloat(partsOfStr[1]),                
                this.dataContact[0].footerContentName,
                this.dataContact[1].footerContentName,
                this.dataContact[5].footerContentName,
                this.dataContact[4].footerContentName,
                this.dataContact[3].footerContentName
                //this.dataContact[7].footerContentName,
                //this.dataContact[6].footerContentName,
                //this.dataContact[5].footerContentName
            );

            /*this.addMarker2(
                parseFloat(partsOfStr2[0]),
                parseFloat(partsOfStr2[1]),                
                this.dataContact[0].footerContentName,
                this.dataContact[3].footerContentName,
                this.dataContact[7].footerContentName,
                this.dataContact[6].footerContentName,
                this.dataContact[5].footerContentName
            ); */

            this.loading = false;
            
        });
    }

    getDefaultMap(){
        this.mymap = L.map('dirmap').setView([2.9414613,101.6575362], 13);
        //this.mymap = L.map('map', { zoomControl:false });
        L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
        // L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', {
            attribution: 'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="http://mapbox.com">Mapbox</a>',
            maxZoom: 20,
            // id: 'mapbox.streets',
            tileSize: 512,
            zoomOffset: -1,
            id: 'mapbox/streets-v11', 
            accessToken: 'pk.eyJ1IjoicmVkemEiLCJhIjoiY2pmcGZxNzRrMjYzbzMwcG83bGRxY2FtZyJ9.uMHQpYc0Pvjl4us27nHH8w'
        }).addTo(this.mymap);
    }

    addMarker(agcLat, agcLong, mName?, mAddress?, mEmail?, mFax?, mPhone?) {
        let mStyle = this.mStyle; //'style="margin: 0px; font-family:' + localStorage.getItem('customFontType') + '; font-size:' + this.fontSize.sizeS + ';"';
        this.marker = L.marker([agcLat, agcLong], {icon:this.defaultIcon})
        .bindPopup(`
        <div class='row'>
            <div class='col-xs-12'>
                <h6 class='font-size-s' ${mStyle} >${mName}<h6>
            </div>
        </div>
        <div class='row'>
            <div class='col-xs-2' class='font-size-s'>
                <i class='fa fa-home' ></i>
            </div>
            <div class='col-xs-10'>
                <p class='font-size-s' ${mStyle} >${mAddress}</p>
            </div>
        </div><br>
        <div class='row'>
            <div class='col-xs-2' class='font-size-s'>
                <i class='fa fa-map-marker'></i>
            </div>
            <div class='col-xs-10'>
                <p class='font-size-s' ${mStyle} >${agcLat},${agcLong}</p>
            </div>
        </div>
        <div class='row'>
            <div class='col-xs-2' class='font-size-s'>
                <i class='fa fa-phone'></i>
            </div>
            <div class='col-xs-10'>
                <p class='font-size-s' ${mStyle} >${mPhone}</p>
            </div>
        </div>
        <div class='row'>
            <div class='col-xs-2' class='font-size-s'>
                <i class='fa fa-fax'></i>
            </div>
            <div class='col-xs-10'>
                <p class='font-size-s' ${mStyle} >${mFax}</p>
            </div>
        </div>
        <div class='row'>
            <div class='col-xs-2' class='font-size-s'>
                <i class='fa fa-envelope'></i>
            </div>
            <div class='col-xs-10'>
                <p class='font-size-s' ${mStyle} >${mEmail}</p>
            </div>
        </div>`)
        .addTo(this.mymap);

      }

      updateMarker(agcLat, agcLong, mName?, mAddress?, mEmail?, mFax?, mPhone?) {
        let mStyle = this.mStyle; 
        let mContent = `
        <div class='row'>
            <div class='col-xs-12'>
                <h6 class='font-size-s' ${mStyle} >${mName}<h6>
            </div>
        </div>
        <div class='row'>
            <div class='col-xs-2' class='font-size-s'>
                <i class='fa fa-home' ></i>
            </div>
            <div class='col-xs-10'>
                <p class='font-size-s' ${mStyle} >${mAddress}</p>
            </div>
        </div><br>
        <div class='row'>
            <div class='col-xs-2' class='font-size-s'>
                <i class='fa fa-map-marker'></i>
            </div>
            <div class='col-xs-10'>
                <p class='font-size-s' ${mStyle} >${agcLat},${agcLong}</p>
            </div>
        </div>
        <div class='row'>
            <div class='col-xs-2' class='font-size-s'>
                <i class='fa fa-phone'></i>
            </div>
            <div class='col-xs-10'>
                <p class='font-size-s' ${mStyle} >${mPhone}</p>
            </div>
        </div>
        <div class='row'>
            <div class='col-xs-2' class='font-size-s'>
                <i class='fa fa-fax'></i>
            </div>
            <div class='col-xs-10'>
                <p class='font-size-s' ${mStyle} >${mFax}</p>
            </div>
        </div>
        <div class='row'>
            <div class='col-xs-2' class='font-size-s'>
                <i class='fa fa-envelope'></i>
            </div>
            <div class='col-xs-10'>
                <p class='font-size-s' ${mStyle} >${mEmail}</p>
            </div>
        </div>`
        this.marker.getPopup().setContent(mContent);
        this.marker.getPopup().update();
      }

      addMarker2(agcLat, agcLong, mName?, mAddress?, mEmail?, mFax?, mPhone?) {
        let mStyle = this.mStyle; //'style="margin: 0px; font-family:' + localStorage.getItem('customFontType') + '; font-size:' + this.fontSize.sizeS + ';"';
        this.marker = L.marker([agcLat, agcLong], {icon:this.defaultIcon})
        .bindPopup(`
        <div class='row'>
            <div class='col-xs-12'>
                <h6 class='font-size-s'>${mName}<h6>
            </div>
        </div>
        <div class='row'>
            <div class='col-xs-2' class='font-size-s'>
                <i class='fa fa-home'></i>
            </div>
            <div class='col-xs-10'>
                <p class='font-size-s' ${mStyle} >${mAddress}</p>
            </div>
        </div><br>
        <div class='row'>
            <div class='col-xs-2' class='font-size-s'>
                <i class='fa fa-map-marker'></i>
            </div>
            <div class='col-xs-10'>
                <p class='font-size-s' ${mStyle} >${agcLat},${agcLong}</p>
            </div>
        </div>`)
        .addTo(this.mymap);

      }

      goToMarkerPoint(latlong) {
        let partsOfStr = latlong.split(',');
        let dLat = parseFloat(partsOfStr[0]);
        let dLong = parseFloat(partsOfStr[1]);
        let dName = this.dataContact[0].footerContentName;
        let dAddress = this.dataContact[1].footerContentName;
        let dEmail = this.dataContact[5].footerContentName;
        let dFax = this.dataContact[4].footerContentName;
        let dPhone = this.dataContact[3].footerContentName;
        //let dEmail = this.dataContact[7].footerContentName;
        //let dFax = this.dataContact[6].footerContentName;
        //let dPhone = this.dataContact[5].footerContentName;

        if (dLat && dLong) {
          this.mymap.flyTo([dLat, dLong], 13);

          this.mymap.once('moveend', ()=> {
            let mStyle = this.mStyle; //'style="margin: 0px; font-family:' + localStorage.getItem('customFontType') + '; font-size:' + this.fontSize.sizeS + ';"';
            this.popup = L.popup()
                .setLatLng([dLat, dLong])
                .setContent(`
                <div class='row'>
                    <div class='col-xs-12'>
                        <h6 class='font-size-s' ${mStyle} >${dName}<h6>
                    </div>
                </div>
                <div class='row'>
                    <div class='col-xs-2' class='font-size-s'>
                        <i class='fa fa-home'></i>
                    </div>
                    <div class='col-xs-10'>
                        <p class='font-size-s' ${mStyle} >${dAddress}</p>
                    </div>
                </div><br>
                <div class='row'>
                    <div class='col-xs-2' class='font-size-s'>
                        <i class='fa fa-map-marker'></i>
                    </div>
                    <div class='col-xs-10'>
                        <p class='font-size-s font-size-s' ${mStyle} >${dLat},${dLong}</p>
                    </div>
                </div>
                <div class='row'>
                    <div class='col-xs-2' class='font-size-s'>
                        <i class='fa fa-phone'></i>
                    </div>
                    <div class='col-xs-10'>
                        <p class='font-size-s' ${mStyle} >${dPhone}</p>
                    </div>
                </div>
                <div class='row'>
                    <div class='col-xs-2' class='font-size-s'>
                        <i class='fa fa-fax'></i>
                    </div>
                    <div class='col-xs-10'>
                        <p class='font-size-s' ${mStyle} >${dFax}</p>
                    </div>
                </div>
                <div class='row'>
                    <div class='col-xs-2' class='font-size-s'>
                        <i class='fa fa-envelope'></i>
                    </div>
                    <div class='col-xs-10'>
                        <p class='font-size-s' ${mStyle} >${dEmail}</p>
                    </div>
                </div>
                `)
                .openOn(this.mymap);
                this.sharedService.loadFontSizeData();
          });
    
        } else
          console.log('latlong are NULL')
      }

      goToMarkerPoint2(latlong) {
        let partsOfStr = latlong.split(',');
        let dLat = parseFloat(partsOfStr[0]);
        let dLong = parseFloat(partsOfStr[1]); 
        let dName = this.dataContact[0].footerContentName;
        let dAddress = this.dataContact[3].footerContentName;

        if (dLat && dLong) {
          this.mymap.flyTo([dLat, dLong], 13);
          
          this.mymap.once('moveend', ()=> {
            this.popup = L.popup()
                .setLatLng([dLat, dLong])
                .setContent(`
                <div class='row'>
                    <div class='col-xs-12'>
                        <h6 class='font-size-s'>${dName}<h6>
                    </div>
                </div>
                <div class='row'>
                    <div class='col-xs-2' class='font-size-s'>
                        <i class='fa fa-home font-size-s'></i>
                    </div>
                    <div class='col-xs-10'>
                        <p class='font-size-s' style='margin: 0px;'>${dAddress}</p>
                    </div>
                </div>
                <div class='row'>
                    <div class='col-xs-2' class='font-size-s'>
                        <i class='fa fa-map-marker font-size-s'></i>
                    </div>
                    <div class='col-xs-10'>
                        <p class='font-size-s' style='margin: 0px;'>${dLat},${dLong}</p>
                    </div>
                </div>
                `)
                .openOn(this.mymap);
                this.sharedService.loadFontSizeData();
          });
    
        } else
          console.log('latlong are NULL')
      }
}




// WEBPACK FOOTER //
// ./src/app/staticpage/contact.component.ts